"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ImageMogr2_1 = tslib_1.__importDefault(require("./ImageMogr2"));
exports.default = ImageMogr2_1.default;
